import { useCallback } from 'react';
import {
  Location,
  NavigateOptions,
  To,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import { Overwrite, TypeUtils } from '../../framework/utils/UtilityTypes';
import { pagePaths } from '../constants/Page';
import { LocationState } from '../routes';

type EngeneNavigateOptions = Overwrite<
  NavigateOptions,
  { state: LocationState }
>;

export interface EngeneNavigateFunction {
  (to: To, options?: EngeneNavigateOptions): void;
  (delta: number): void;
  (): void;
}

export interface EngeneLocation extends Location {
  state: LocationState;
}

/**
 * カスタマイズした useNavigate
 * @returns
 */
export const useEngeneNavigate = () => {
  const navigateOriginal = useNavigate();
  const location = useLocation() as EngeneLocation;

  const navigate = useCallback(
    (to: unknown, options?: EngeneNavigateOptions) => {
      if (typeof to === 'number') {
        // (delta: number): void;
        navigateOriginal(to);
        return;
      }

      if (TypeUtils.isNil(to)) {
        // (): void;
        // console.log(location.state?.from);
        navigateOriginal(
          TypeUtils.isNil(location.state?.from)
            ? pagePaths.TOP
            : location.state.from,
          options
        );
        return;
      }

      // (to: To, options?: EngeneNavigateOptions): void;
      navigateOriginal(to as To, {
        ...(options || {}),
        state: {
          from: `${location.pathname}${location.search}`,
          ...(options || {})?.state,
        },
      });
    },
    [location]
  );

  return navigate as EngeneNavigateFunction;
};

// export declare function useEngeneNavigate(): EngeneNavigateFunction;
